import { DASHBOARD_BASE } from "./constants";
import { ADMIN_ROUTES } from "./admin";
import { BOX_OFFICE_ROUTES } from "./box-office";
import { EVENTS_ROUTES } from "./events";
import { REPORTS_ROUTES } from "./reports";
import { MEMBERSHIPS_ROUTES } from "./memberships";
import { ACCOUNT_ROUTES } from "./account";
import { NETWORK_ROUTES } from "./network";
import { SHOWIRE_ROUTES } from "./showire";

/**
 * Dashboard Route Constants
 *
 * Centralized route paths for all dashboard features.
 * Each section is defined in its own file for better organization and maintainability.
 *
 * Structure:
 * - Basic routes without subroutes are kept flat for convenience
 * - Complex routes with subroutes or dynamic helpers are nested for clarity
 *
 * @example
 * // Basic routes - direct access
 * DASHBOARD_ROUTES.BOX_OFFICE.SELL
 * DASHBOARD_ROUTES.EVENTS.LIST
 *
 * @example
 * // Nested routes - organized by section
 * DASHBOARD_ROUTES.BOX_OFFICE.SETTINGS.SQUARE
 * DASHBOARD_ROUTES.BOX_OFFICE.GROUPS.team(123)
 * DASHBOARD_ROUTES.ADMIN.EXAMPLE_DASHBOARD.detail(456)
 */
export const DASHBOARD_ROUTES = {
  ROOT: DASHBOARD_BASE,
  ADMIN: ADMIN_ROUTES,
  BOX_OFFICE: BOX_OFFICE_ROUTES,
  EVENTS: EVENTS_ROUTES,
  REPORTS: REPORTS_ROUTES,
  MEMBERSHIPS: MEMBERSHIPS_ROUTES,
  ACCOUNT: ACCOUNT_ROUTES,
  NETWORK: NETWORK_ROUTES,
  SHOWIRE: SHOWIRE_ROUTES,
} as const;
